export const EXTERNAL_ROUTES = {
  HELP_CENTER: 'https://support.photobucket.com',
  CONTACT_US: 'https://support.photobucket.com/hc/en-us/articles/115012656667-How-to-Contact-Photobucket-for-Support',
  STUDENT_DISCOUNTS: 'https://www.studentbeans.com/en-us/us/beansid-connect/hosted/photobucket',
  OTHER_DISCOUNTS: 'https://www.studentbeans.com/en-us/us/beansid-connect/hosted/photobucket-discounts',
  FACEBOOK: 'https://www.facebook.com/photobucket',
  TWITTER: 'https://twitter.com/photobucket',
  INSTAGRAM: 'https://www.instagram.com/photobucket',
  PINTEREST: 'https://www.pinterest.com/photobucket/',
  BLOG: 'https://blog.photobucket.com',
  AFFILIATE_PROGRAM: 'https://my.photobucket.com/affiliate_program_overview',
  PRINTSHOP_CANVAS_PRINTS:
    'https://www.printshoplab.com/products/canvas?utm_medium=pbhomepage&utm_source=pbfooterlink&utm_content=pslcanvaslink&utm_campaign=pslcanvaspage',
  PRINTSHOP_PRINTS:
    'https://www.printshoplab.com/prints-and-enlargements?utm_medium=pbhomepaget&utm_source=pbfooterlink&utm_content=pslprintslink&utm_campaign=pslprintpage',
  PRINTSHOP_PHOTO_BOOKS:
    'https://www.printshoplab.com/products/photo-books?utm_medium=pbhomepage&utm_source=pbfooterlink&utm_content=pslphotobookslink&utm_campaign=photobookspage',
  PRINTSHOP_CARDS:
    'https://www.printshoplab.com/products/photo-cards?utm_medium=pbhomepage&utm_source=pbfooterlink&utm_content=pslgreetingcardslink&utm_campaign=greetingcardpage',
  PRINTSHOP_GIFTS: 'https://www.printshoplab.com/gifts?utm_medium=pbhomepage&utm_source=pbfooterlink&utm_content=pslgiftslink&utm_campaign=giftspage',
  PB_CAPTURE: 'https://pb.capture.com/',
  SUPPORT_EMAIL: 'mailto:support@photobucket.com',
  ABUSE_EMAIL: 'mailto:abuse@photobucket.com',
  POLICIES_EMAIL: 'mailto:policies@photobucket.com',
  DELETE_ACCOUNT: 'https://my.photobucket.com/photobucket-account-deletion-step1',
  REGIONAL_LAWS: 'https://content.photobucket.com/regional-laws.pdf'
}

export const INTERNAL_ROUTES = {
  PRIVACY_POLICY: '/legal/privacy-policy',
  BIOMETRIC_POLICY: '/legal/biometric-information-privacy-policy',
  COPYRIGHT_POLICY: '/legal/copyright-policy',
  TERMS_OF_SERVICE: '/legal/terms-of-service'
}
